
import incrediButton from '@/components/common/incrediButton.vue';
import { defineComponent } from 'vue';
import { keyDownA11y } from '@/services/utils';
import COLORS from '@/design-system/colors.json';

export default defineComponent({
  components: { incrediButton },
  props: {
    title: {
      type: String,
      default: '',
    },
    seperator: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return { keyDownA11y, COLORS };
  },
  computed: {
    attrsComputed() {
      const { ...args } = this.$attrs;
      return args;
    },
  },
});
